import styled, { css } from "styled-components";
export const GridMoreBaseBox = styled.section `
	width: inherit;
	margin: 0 auto;
	display: grid;
	${(props) => {
    const { gridCol = 5, gridGap = 12 } = props;
    return css `
			grid-gap: ${gridGap}px;
			grid-template-columns: repeat(${gridCol}, 1fr);
		`;
}}
`;
export const ProductCard = styled.a `
	${(props) => {
    return css `
			width: ${props.width}px;
		`;
}}
	position: relative;
	background-color: #fff;
	font-family: Avenir-Book, Avenir;
	border-radius: 6px 6px 0 0;
`;
export const ProductCardPoster = styled.div `
	width: 100%;
	position: relative;
	font-size: 0px;
`;
export const DescriptionWrap = styled.div `
	padding: 10px;
`;
